import React from 'react'
import { Columns, Logo, P, Text, ThemeProvider, IconManager, ecommerceLogoPack } from '@deseretbook/react-ui'

IconManager.register(ecommerceLogoPack)

const StorePickupLogo = () => (
  <ThemeProvider>
    <Columns isMobile style={{ display: 'flex', alignItems: 'center' }}>
      <Columns.Column
        size={{
          tiny: 2,
          small: 1,
        }}
      >
        <Text color="primary" size="tiny">NEW</Text>
      </Columns.Column>
      <Columns.Column size={4} className="is-paddingless">
        <Logo name="storePickup" />
      </Columns.Column>
      <Columns.Column>
        <P>
          <Text size="tiny">(shipping time varies by location) : </Text>
          <Text color="primary" size="tiny">Free</Text>
        </P>
      </Columns.Column>
    </Columns>
  </ThemeProvider>
)

export default StorePickupLogo
